import { render } from "./ModalCancelRemark.vue?vue&type=template&id=1283e451"
import script from "./ModalCancelRemark.vue?vue&type=script&lang=ts"
export * from "./ModalCancelRemark.vue?vue&type=script&lang=ts"
script.render = render

export default script